import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import RealTime from './RealTime'
import useDebouncedCallback from '@/v2/hooks/useDebouncedCallback'

const RTMonthlyCalendar = ({ monthNumber, year }) => {
  const queryClient = useQueryClient()

  const handleEvent = useDebouncedCallback(({ action, subject, data }) => {
    queryClient.invalidateQueries({
      queryKey: ['calendarOccupancy', year, monthNumber],
      cancelRefetch: true,
    })

    if (subject === 'appointment' || !subject) {
      queryClient.invalidateQueries({
        queryKey: ['appointments'],
        cancelRefetch: true,
      })
    }
  }, 500)

  return (
    <RealTime
      channel="Calendar::MonthChannel"
      onEvent={handleEvent}
      monthNumber={monthNumber}
      year={year}
    />
  )
}

export default RTMonthlyCalendar
